import axios from 'axios'

export const ProfileService = {
    loadProfile: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/profile')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    saveProfile: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/profile', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/services/profile-service.js